// Standard library imports
import React, { useState, useEffect } from 'react';
// External library imports
import _ from 'lodash';
// Internal module imports
import { useQueryParamWithDefault } from '../../../../hooks';
import { NumberParam, } from 'use-query-params';
import TabsComponent from '../../../../components/Tabs/Tabs';
import { ActivationGlobalChips } from './ActivationGlobalChips';
import { ActivationEdgeChips } from './ActivationEdgeChips';


export const Activations = ({ eicCodeOptions, cId }) => {
    const [selectedIndex, setSelectedIndex] = useQueryParamWithDefault('subTab', NumberParam, 0, cId);
    let tabs = [
        {
            name: 'Global',
            component: (
                <>
                    <ActivationGlobalChips eicCodeOptions={eicCodeOptions} cId={cId} />
                </>
            ),
            tabId: 1,
        },
        {
            name: 'Edge',
            component: (
                <>
                    <ActivationEdgeChips eicCodeOptions={eicCodeOptions} cId={cId} />
                </>
            ),
            tabId: 2,
        },
    ];

    return (
        <div className=" ventilation">
            <TabsComponent
                selectedIndex={selectedIndex}
                tabs={tabs}
                onChangeTab={(index) => {
                    setSelectedIndex(index);
                }}
                cId={cId}
            />
        </div>
    );
};
